import {useState} from "react";
import {Form, Modal} from "semantic-ui-react";
import {useAppDispatch} from "../../app/hooks";
import {useNavigate, useParams} from "react-router-dom";
import {ChangePassword} from "./AuthActions";
import { useTranslation } from "react-i18next";
interface Props {
  show: boolean;
  onHide: () => void;
  token?: string;
}
const ChangePassModal = ({show, onHide, token}: Props) => {
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [errors, setErrors] = useState({password: "", repeatPassword: ""});
  const dispatch = useAppDispatch();
  const {t} = useTranslation(); 

  const closeForm = () => {
    setPassword("");
    setRepeatPassword("");
    setErrors({password: "", repeatPassword: ""});
    onHide();
  };
  const validateForm = () => {
    let valid = true;
    let errors = {password: "", repeatPassword: ""};

    if (!password) {
      valid = false;
      errors.password = t("enter_password");
    } else if (!/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/.test(password) || password.length < 6) {
      valid = false;
      errors.password = t("password_rules");
    } else if (password !== repeatPassword) {
      valid = false;
      errors.repeatPassword = t("passwords_not_match");
    }

    if (token === undefined || token === "") {
      valid = false;
      errors.password = t("request_new_link_err");
    }
    setErrors(errors);
    return valid;
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (validateForm()) {
      dispatch(ChangePassword(token!, password));
      closeForm();
    }
  };

  return (
    <Modal size="mini" centered closeIcon open={show} onClose={closeForm}>
      <Modal.Header style={loginstyles.header}>{t("change_pass_title")}</Modal.Header>
      <Modal.Content>
        <Form onSubmit={handleSubmit}>
          <Form.Field>
            <label>{t("new_pass")}</label>
            <Form.Input
              type="password"
              placeholder={t("insert_new_pass")}
              value={password}
              onChange={(e) => {
                setErrors({password: "", repeatPassword: ""});
                setPassword(e.target.value);
              }}
              error={errors.password ? {content: errors.password} : false}
            />
          </Form.Field>
          <Form.Field>
            <label>{t("repeat_new_pass")}</label>
            <Form.Input
              type="password"
              placeholder={t("repeat_new_pass2")}
              value={repeatPassword}
              onChange={(e) => {
                setErrors({password: "", repeatPassword: ""});
                setRepeatPassword(e.target.value);
              }}
              error={errors.repeatPassword ? {content: errors.repeatPassword} : false}
            />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Form.Button style={loginstyles.button} primary type="submit" onClick={handleSubmit}>
          {t("submit_btn")}
        </Form.Button>
      </Modal.Actions>
    </Modal>
  );
};

const loginstyles = {
  header: {
    textAlign: "center",
  },
  button: {
    width: "100%",
  },
  registerButton: {
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    textAlign: "center",
    width: "100%",
    marginTop: 10,
    cursor: "pointer",
  },
};

const ChangePass = () => {
  const [show, setShow] = useState(true);
  const navigate = useNavigate();
  const params = useParams();
  const handleHide = () => {
    navigate("/", {replace: true});
    setShow(false);
  };
  return (
    <div>
      <ChangePassModal show={show} onHide={handleHide} token={params.token} />
    </div>
  );
};
export default ChangePass;
